/* eslint-disable react-hooks/rules-of-hooks */
import { Grid, Link } from "@mui/material"
import { crudGetList, ShowBase, useRecordContext } from "ra-core"
import { FC, memo, useEffect } from "react"
import { useDispatch } from "react-redux"
import { Switch, Route } from "react-router-dom"
import { Content } from "@/components/content/Content"
import FieldsMappingList from "@/components/settings/encryption/FieldsMappingList"
import { TableSelectionCard } from "@/components/settings/encryption/TableSelectionCard"
import { OdResourcePageProps } from "@/types/resource"
import { pages, sorts } from "@/utils/paramsWithGetMainList"
import { useMutateEncryptionMappingsController } from "./mutateEncryptionMappingsController"
import { MutateEncryptionMappingsContextProvider } from "./mutateEncryptionMappingsContext"
import { useResourceRegister } from "@/utils/resourceRegister"
import { decodeHashid, genUrlWithHashid } from "@/utils/hashid"
import { RecPatch } from "@/dataProvider/tools"
import EditNoSqlEncryptionMappings from "./EditNoSqlEncryptionMappings"
import { EncryptionMappingResponseDto } from "@/gen/api/governance"
import { useEventBus } from "@/contexts/EventBusContext/useEventBus"


const UpdateEncryptionMappings: FC<OdResourcePageProps> = (props) => {
  useResourceRegister({ name: 'db-fields-mapping-count' })
  useResourceRegister({ name: 'tables' })
  useResourceRegister({ name: 'fields' })
  useResourceRegister({ name: 'collection-properties' })
  useResourceRegister({ name: 'mapping-rules' })
  
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(
      crudGetList('mappings-update', pages(), sorts(), {})
    )
    dispatch(
      crudGetList('encryption/mappings', pages(), sorts(), {})
    )
  }, [dispatch])
  
  const { match } = props
  if (!match?.params['dbId']) return null;
  const basePath = match ? match.path : '';
  const id = decodeHashid(match.params['dbId'] || '')

  return (
    <Switch>
      <Route path={`${basePath}/ns`}>
        <EditNoSqlEncryptionMappings id={id} {...props} />
      </Route>
      <Route path={`${basePath}`}>
        <ShowBase resource="mappings-update" id={id} basePath="">
          <UpdateEncryptionMappingsBody id={id} {...props} />
        </ShowBase>
      </Route>
    </Switch>
  )
}

export const UpdateEncryptionMappingsBody: FC<OdResourcePageProps&RecPatch> = memo(function comp({
  id,
  match,
  options,
  resource,
}: OdResourcePageProps&RecPatch) {
  const { encryptMappingCtrl } = useMutateEncryptionMappingsController('update')
  const record = useRecordContext<EncryptionMappingResponseDto & RecPatch>()
  useEventBus('fields-mapping-list')
  
  return (
    <MutateEncryptionMappingsContextProvider value={encryptMappingCtrl}>
      <Content 
        pageName="Update Encryption Mappings" 
        resourceName="Update Encryption Mappings" 
        breadcrumbs={options?.breadcrumbs}
        mainActions={
          record &&
          <Link href={genUrlWithHashid(`/encryption/obfs/mappings/$0/edit`, record.databaseId!, record.databaseName)} target="_blank" variant="caption"
            sx={{ mb: 1, mr: 1, display: 'inline-block' }}
          >
            Obfuscation Mappings...
          </Link>
        }
      >
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TableSelectionCard useSource="pending-tables" />
          </Grid>
          <Grid item xs={12}>
            <FieldsMappingList />
          </Grid>
        </Grid>
      </Content>
    </MutateEncryptionMappingsContextProvider>
  )
})

export default UpdateEncryptionMappings;
